import React from "react";
import "./Cards.css";
import CardItem from "./CardItem";

function Cards() {
  return (
    <div className="cards">
      <h1>
        This is my personal blog about mastering life and finding fulfillment
      </h1>
      <div className="cards__container">
        <div className="cards__wrapper">
          <ul className="cards__items">
            <CardItem
              src="https://images.unsplash.com/photo-1500856056008-859079534e9e?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1051&q=80"
              title="Short improvement thoughts"
              label="Improvement Nuggets"
              path="/improvement-nuggets"
              subtitle=""
            />
            <CardItem
              src="https://images.unsplash.com/photo-1452421822248-d4c2b47f0c81?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=967&q=80"
              title="My story as a dropout from mediocrity"
              label="Escaping Mediocrity"
              path="/escaping-mediocrity"
              subtitle=""
            />
          </ul>
        </div>
      </div>
    </div>
  );
}

export default Cards;
